export const GET_USER_LIST = "GET-USER-LIST";
export const GET_OPPORTUNITY_RESOURCE_DATA = "GET_OPPORTUNITY_RESOURCE_DATA";

